export const timeToComplete = (userFirstInteraction: number): number => {
	if (!userFirstInteraction) return 0;
	const now = Date.now();
	const seconds = ((now - userFirstInteraction) / 1000).toFixed(0);

	return +seconds;
};
